import { MemberProfile } from "@/services/core-api-adapter";
import { ConsultationTypeSelection } from ".";

export default function ConsultationTypeSelectionExamples() {
  function onSelectNurseConsult() {
    console.log("Continue button");
  }

  function onSelectDirectToDoctor() {
    console.log("Starting new session");
  }

  function onSeeAllConditionsClick() {
    console.log("See all conditions");
  }
  function onDocMedBundleClick() {
    console.log("Doc Med Bundle Clicked");
  }

  return (
    <>
      <ConsultationTypeSelection
        onNurseConsultClick={onSelectNurseConsult}
        onDirectToDoctorConsultClick={onSelectDirectToDoctor}
        onSeeAllConditionsClick={onSeeAllConditionsClick}
        onDocMedBundleClick={onDocMedBundleClick}
        memberProfile={
          {
            firstName: "Susan",
            consultation: {
              isDiscountApplied: true,
              consultationResponses: [],
              consultationRates: [
                {
                  isDiscountApplied: true,
                  chargeCode: "ONLINE_DOCTOR_CONSULTATION",
                  amount: "R90.00",
                  amountFormatted: "R90",
                  originalAmount: "R179.00",
                  originalAmountFormatted: "R179",
                },
                {
                  isDiscountApplied: true,
                  chargeCode: "DIGITAL_DOCTOR_CONSULT",
                  amount: "R90.00",
                  amountFormatted: "R90",
                  originalAmount: "R179.00",
                  originalAmountFormatted: "R179",
                },
                {
                  isDiscountApplied: false,
                  chargeCode: "CHAT_TO_A_NURSE",
                  amount: "R95.00",
                  amountFormatted: "R95",
                },
              ],
            },
            pathology: {
              isDiscountApplied: true,
              originalAmount: 17900,
              amount: 9200,
              currencyCode: "ZAR",
            },
            memberServiceOfferingUsageCount: "1",
            healthProfile: {
              lastUpdatedAt: "2022-07-08T10:26:04Z",
              healthScoreValue: 85,
            },
            benefitCount: 11,
            dependentCount: 1,
            membership: {
              id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
              fullName: "Susan",
              beneficiaryCode: "00",
              productCode: "UNU01",
              productFriendlyName: "Unu forFree",
              membershipNumber: "UNU-725",
              dependentCount: 1,
              status: "ACTIVE",
            },
            product: {
              pharmacySwitchCode: null,
              provider: null,
              administrator: {
                id: "38d556f7-5302-4ea7-a1a4-660371b7d953",
                code: "NHG",
                name: "National Health Group",
                FileUri: "{{STATIC_PLACEHOLDER_DOCUMENT_URI}}",
                timeZone: "UTC+02:00",
                supportedServices: [
                  {
                    type: "CALL_CENTRE",
                    channels: [
                      {
                        type: "PHONE",
                        value: "+27860222286",
                        availability: [],
                      },
                      {
                        type: "EMAIL",
                        value: "test@test.com",
                        availability: [],
                      },
                      {
                        type: "WHATSAPP",
                        value: null,
                        availability: [],
                      },
                    ],
                  },
                ],
              },
            },
          } as unknown as MemberProfile
        }
      />
    </>
  );
}
